import React, { useCallback, useRef, useState } from 'react';
import {
	ExploreButton,
	Header,
	LoadingContainer,
	NoData,
	SectionWrapper,
	Title,
} from './ChartList.styles';
import HighchartsReact from 'highcharts-react-official';
import HighchartsMap from 'highcharts/modules/map';
import * as Highcharts from 'highcharts';
import usAllMap from '@highcharts/map-collection/countries/us/us-all.geo.json';
import {
	ApButtonSecondary,
	ApIcon,
	ApLoaderDefault,
	ApLoaderText,
	colors,
} from '@alixpartners/ui-components';
import { renderToString } from 'react-dom/server';
import Tooltip from '../Components/Tooltip';
import _ from 'lodash';
import { useFilterContext } from 'contexts/FilterContext';
import filterNames from 'utils/filterNames';
import { MultiSelectWrapper } from '../WidgetSettings.js/WidgetSettings.styles';
import CategoryMultiSelect from 'Settings/FirstUsageSettings/CategoryMultiSelect';
import { useChartContext } from 'contexts/CategoryChartContext';
import ExpandedModal from '../Components/ExpandedModal';

HighchartsMap(Highcharts);

const BLSCity = ({ chartTitle, chartheight, isParent, chartData }) => {
	const [isExpandedView, setIsExpandedView] = useState(false);
	const chartRef = useRef();
	const { state: newState, actions } = useFilterContext();

	const initialBlsCitySettings = {
		[filterNames.mapCityWorkerType]: newState.mapCityWorkerType,
		[filterNames.mapCityBLSYear]: newState.mapCityBLSYear,
	};
	const { setMultipleFilters } = actions;
	const { state } = useChartContext();
	const { blscityLoading } = state;

	const [blsCitySettings, setBLSCitySettings] = useState(
		initialBlsCitySettings
	);

	const handleChange = useCallback((evnt, action, chart) => {
		if (action === 'workerType' && chart === 'mapcity') {
			setBLSCitySettings(prev => ({
				...prev,
				[filterNames.mapCityWorkerType]: evnt,
			}));
		}
		if (action === 'blsyear' && chart === 'mapcity') {
			setBLSCitySettings(prev => ({
				...prev,
				[filterNames.mapCityBLSYear]: evnt,
			}));
		}
	}, []);

	const options = {
		chart: {
			map: usAllMap,
			borderWidth: 0,
			style: { fontFamily: 'Roboto' },
			height: chartheight,
			spacingBottom: 0,
			spacingTop: 0,
		},
		title: {
			text: '',
		},
		boost: {
			useGPUTranslations: true,
		},

		exporting: { enabled: false },
		credits: {
			enabled: false,
		},

		mapNavigation: {
			enabled: false,
			enableMouseWheelZoom: true,
			buttonOptions: {
				verticalAlign: 'middle',
			},
		},
		tooltip: {
			shared: true,
			useHTML: true,
			backgroundColor: 'rgba(255,255,255, 0.9)',
			borderWidth: 0,
			borderRadius: 2,
			outside: true,
			formatter: function() {
				const { point } = this;

				return renderToString(
					<Tooltip tooltipData={point?.tooltip} color={point.color} />
				);
			},
		},

		legend: {
			title: {
				text:
					'<span style="font-weight:lighter;font-size:11px">Average H Median</span>',
			},
		},
		series: [
			{
				data: [],
				keys: ['name', 'value'],
				color: '#DBE9ED',
				shadow: false,
				name: 'map',
				borderColor: colors.blue900,
				borderWidth: 0.25,
				cursor: 'pointer',
				states: {
					hover: {
						brightness: 1,
						borderWidth: 0.25,
						borderColor: colors.grey8,
					},
				},
			},
			{
				name: 'Cities',
				type: 'mapbubble',
				colorKey: 'avG_H_MEDIAN',
				data: chartData,
				shadow: false,
				minSize: '1%',
				maxSize: '20%',
				borderColor: '#FFFFFF',
				borderWidth: 1,
				dataLabels: {
					align: 'left',
					verticalAlign: 'middle',
				},

				marker: {
					lineColor: 'black',
					lineWidth: 0.5,
					fillOpacity: 0.7,
				},
				animation: false,
			},
		],
	};
	return (
		<SectionWrapper>
			<Header>
				<Title>{chartTitle}</Title>
				{isParent && (
					<ExploreButton
						title="Explore"
						className="explore"
						onClick={() => setIsExpandedView(true)}
					>
						<ApIcon title="Explore" material={true} iconName="find_in_page" />
					</ExploreButton>
				)}
			</Header>
			{!isParent && (
				<div style={{ display: 'flex' }}>
					<MultiSelectWrapper>
						<CategoryMultiSelect
							name="Worker type"
							onChange={e => handleChange(e, 'workerType', 'mapcity')}
							options={newState.workerTypeOptions}
							selected={blsCitySettings.mapCityWorkerType}
							label="Worker type"
						/>
					</MultiSelectWrapper>

					<MultiSelectWrapper>
						<CategoryMultiSelect
							name="BLS Year"
							onChange={e => handleChange(e, 'blsyear', 'mapcity')}
							options={newState.blsYearOptions}
							selected={blsCitySettings.mapCityBLSYear}
							label="BLS Year"
						/>
					</MultiSelectWrapper>
					<ApButtonSecondary
						onClick={() => {
							const obj = {};
							for (const key in blsCitySettings) {
								if (
									Array.isArray(blsCitySettings[key]) &&
									blsCitySettings[key].length > 0
								) {
									obj[key] = blsCitySettings[key];
								}
							}
							setMultipleFilters(obj);
						}}
						style={{ marginLeft: 'auto' }}
					>
						Save
					</ApButtonSecondary>
				</div>
			)}
			{blscityLoading === true ? (
				<LoadingContainer>
					<ApLoaderDefault loaderText={() => <ApLoaderText />} />
				</LoadingContainer>
			) : (
				<>
					{chartData.length === 0 ? (
						<NoData>No data available</NoData>
					) : (
						<>
							<HighchartsReact
								highcharts={Highcharts}
								options={{
									...options,
									colorAxis: {
										min: _.minBy(chartData, 'avG_H_MEDIAN').avG_H_MEDIAN,
										max: _.maxBy(chartData, 'avG_H_MEDIAN').avG_H_MEDIAN,
										tickInterval:
											_.maxBy(chartData, 'avG_H_MEDIAN').avG_H_MEDIAN / 5,
										stops: [
											[0.3, '#22763f'],
											[0.5, '#fee401'],
											[0.7, '#be2a3e'],
										],
										labels: {
											formatter: function() {
												return Highcharts.numberFormat(this.value, 0); // Format labels with two decimal points
											},
										},
									},
								}}
								constructorType="mapChart"
								ref={chartRef}
							/>
							{isExpandedView && (
								<ExpandedModal
									heading={chartTitle}
									show={true}
									handleClose={() => setIsExpandedView(state => !state)}
								>
									<BLSCity chartheight={'31%'} chartData={chartData} />
								</ExpandedModal>
							)}
						</>
					)}
					<span
						style={{
							fontWeight: 'lighter',
							fontSize: '11px',
							margin: '0 auto 0 auto',
						}}
					>
						*The size of the bubble is determined by Sum of Total Employees
					</span>
				</>
			)}
		</SectionWrapper>
	);
};
export default React.memo(BLSCity);
